import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'container', 'input', 'icon' ]
  static values = { url: String, scope: String }

  connect() {
    this.toggleInputClass = ['w-28', 'sm:w-80']
    this.toggleContainerClass = 'bg-gray-75'
    this.toggleIconClass = 'text-gray-400'
  }

  expand() {
    this.inputTarget.classList.add(...this.toggleInputClass)
    this.inputTarget.focus()
    this.containerTarget.classList.add(this.toggleContainerClass)
    this.iconTarget.classList.add(this.toggleIconClass)
  }

  shrink() {
    this.inputTarget.classList.remove(...this.toggleInputClass)
    this.inputTarget.value = ''
    this.containerTarget.classList.remove(this.toggleContainerClass)
    this.iconTarget.classList.remove(this.toggleIconClass)
  }

  submit(e) {
    if (e.keyCode === 13) {
      window.location = `${this.data.get('url')}?q=${this.inputTarget.value}`
    }
  }
}
